import { Link } from '@tanstack/react-router';

export function NotFound() {
  return (
    <div className="mx-auto flex min-h-[60dvh] max-w-[560px] flex-col justify-center px-5 py-16">
      <p className="font-mono text-sm font-bold text-brand-ink">404</p>
      <h1 className="mt-2 text-[32px] font-extrabold tracking-[-0.03em]">
        We could not find that.
      </h1>
      <p className="mt-3 text-[17px] text-muted">
        The link may be out of date, or the reference may have been mistyped.
      </p>
      <div className="mt-8 flex flex-wrap gap-3">
        <Link
          to="/"
          className="inline-flex h-12 items-center rounded-[10px] bg-brand-strong px-5 font-semibold text-on-brand"
        >
          Back to the store
        </Link>
        <Link
          to="/custom"
          className="inline-flex h-12 items-center rounded-[10px] border border-line-strong bg-panel px-5 font-semibold"
        >
          Start a custom order
        </Link>
      </div>
    </div>
  );
}
